export interface MenuItem {
    text?: string;
    title: string;
    href?: string;
    target?: string;
    items?: MenuItem[];
    type?: string;
    icon?: string;
    open?: boolean;
}

export enum MenuItemType {
    Login = 'login',
    Logout = 'logout',
    Profile = 'profile',
}
